import $ from 'jquery';
import lodash from 'lodash';
import HistoryManager from '../util/HistoryManager';

const CheckboxService = {
    callback: {
        onchange: {},
        onquery: {},
    },
    getControl(id) {
        const control = $(`.control--${id}`);
        return {
            id,
            dom: {
                control,
                value: control.find('.control-сheckbox__value'),
            },
            config: {
                name: control.attr('data-name'),
                isSubmit: control.hasClass('control--submit'),
                isQuery: control.hasClass('control--query'),
                isGroup: control.hasClass('control--group'),
            },
        };
    },
    onQuery(id, callback) {
        this.callback.onquery[id] = callback;
    },
    onQueryDefault(controlObject) {
        const checked = controlObject.dom.value.prop('checked');
        const value = controlObject.dom.value.val();
        const { name, isGroup } = controlObject.config;

        if (checked) {
            if (isGroup) {
                let currentValue = HistoryManager.current().getParameter(name);
                if (!currentValue) {
                    currentValue = [];
                }
                currentValue.push(value);
                currentValue = lodash.uniq(currentValue);
                HistoryManager.current().set(name, currentValue).apply();
            } else {
                HistoryManager.current().set(name, value).apply();
            }
        } else {
            if (isGroup) {
                let currentValue = HistoryManager.current().getParameter(name);
                if (!currentValue) {
                    currentValue = [];
                }
                currentValue = currentValue.filter(val => val != value);
                HistoryManager.current().set(name, currentValue).apply();
            } else {
                HistoryManager.current().remove(name).apply();
            }
        }
    },
    onChange(id, callback) {
        if (!this.callback.onchange[id]) {
            this.callback.onchange[id] = [];
        }
        this.callback.onchange[id].push(callback);
    },
    triggerChange(id, value) {
        if (this.callback.onchange[id]) {
            this.callback.onchange[id].forEach((callback) => {
                callback(value);
            });
        }
    },
    triggerSubmit(id) {
        const control = this.getControl(id);
        control.dom.control.parents('form').submit();
    },
    getValue(id) {
        const control = this.getControl(id);

        return control.dom.value.prop('checked');
    },
    setValue(id, checked) {
        const controlObject = this.getControl(id);
        controlObject.dom.value.prop('checked', checked);
        const value = checked ? controlObject.dom.value.val() : false;

        /*
            CHANGE
        */
        this.triggerChange(id, value);

        /*
            QUERY
        */
        if (controlObject.config.isQuery) {
            if (this.callback.onquery[id]) {
                this.callback.onquery[id](controlObject);
            } else {
                this.onQueryDefault(controlObject);
            }
        }

        /*
            SUBMIT
        */
        if (controlObject.config.isSubmit) {
            this.triggerSubmit(id);
        }

        return {
            id,
            value
        };
    }
};
window.checkbox = CheckboxService;
export default CheckboxService;
